
import { inject, Injectable, DOCUMENT } from '@angular/core';

/**
 * Provides testable access to browser DOM and Window objects.
 *
 * Enables dependency injection of browser globals for:
 * - Unit testing (mock window/document)
 * - Server-side rendering (SSR) compatibility
 * - Consistent browser API access
 *
 * Use this instead of direct `window` or `document` access in services.
 */
@Injectable({
  providedIn: 'root',
})
export class DomAccessor {

  public document = inject(DOCUMENT);
  public window = this.document.defaultView as Window;
}
